<input #frontFileInput (change)="onLoadFront($event)" [accept]="acceptFormats" type="file">
<input #backFileInput (change)="onLoadBack($event)" [accept]="acceptFormats" type="file">
<input #additionalFileInput (change)="onLoadAdditional($event)" [accept]="acceptFormats" type="file">

<div class="documents-container">
  <div class="document-type vertical data-field">
    <mat-radio-group (change)="this.onSelectedDocumentChange()" [(ngModel)]="selectedDocument">
      <mat-radio-button *ngFor="let document of documents" [value]="document">
        {{ 'Documents.' + document.id + '.Title' | translate }}
      </mat-radio-button>
    </mat-radio-group>
  </div>

  <ng-container *ngIf="selectedDocument">
    <div class="document-info with-icon">
      <img alt="info" src="/img/info-icon.svg">
      <div [innerHTML]="'Documents.' + selectedDocument.id + '.AddressInfo' | translate | safe:'html'"></div>
    </div>

    <div class="upload-container">
      <div *ngIf="selectedDocument.requiredFront" [ngClass]="{'filled': frontDocument}" class="file-container">
        <button (click)="frontFileInput.click()" [disabled]="isBusy[additionalDocumentType.ProofAddressFront]"
                mat-button>
          <ng-container *ngIf="!frontDocument">
            <img alt="attach" src="/img/attach.svg">
            {{ 'Documents.' + selectedDocument.id + '.AttachFront' | translate }}
          </ng-container>

          <ng-container *ngIf="frontDocument">
            <img alt="attach" src="/img/attach.svg">
            {{ 'Documents.AttachedFront' | translate }}
          </ng-container>
        </button>

        <div *ngIf="frontDocument" class="file">
          <button (click)="onRemoveFront()" [disabled]="isBusy[additionalDocumentType.ProofAddressFront]"
                  class="remove">
            <img alt="remove" src="/img/remove.svg">
          </button>
          <div> {{ frontDocument.fileName }}</div>
          <img alt="mark" src="/img/file.svg">
        </div>
      </div>

      <div *ngIf="selectedDocument.requiredBack" [ngClass]="{'filled': backDocument}" class="file-container">
        <button (click)="backFileInput.click()" [disabled]="isBusy[additionalDocumentType.ProofAddressBack]" mat-button>
          <ng-container *ngIf="!backDocument">
            <img alt="attach" src="/img/attach.svg">
            {{ 'Documents.' + selectedDocument.id + '.AttachBack' | translate }}
          </ng-container>

          <ng-container *ngIf="backDocument">
            <img alt="attach" src="/img/attach.svg">
            {{ 'Documents.AttachedBack' | translate }}
          </ng-container>
        </button>

        <div *ngIf="backDocument" class="file">
          <button (click)="onRemoveBack()" [disabled]="isBusy[additionalDocumentType.ProofAddressBack]" class="remove">
            <img alt="remove" src="/img/remove.svg">
          </button>
          <div> {{ backDocument.fileName }}</div>
          <img alt="mark" src="/img/file.svg">
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="selectedDocument && selectedDocument.requiredAdditional">

    <div [innerHTML]="'Documents.Additional.Title' | translate | safe:'html'" class="additional-file"></div>

    <div class="upload-container">
      <div [ngClass]="{'filled': additionalDocument}" class="file-container">
        <button (click)="additionalFileInput.click()" [disabled]="isBusy[additionalDocumentType.ProofAddressAdditional]"
                mat-button>
          <ng-container *ngIf="!additionalDocument">
            <img alt="attach" src="/img/attach.svg">
            {{ 'Documents.Additional.AttachBack' | translate }}
          </ng-container>

          <ng-container *ngIf="additionalDocument">
            <img alt="attach" src="/img/attach.svg">
            {{ 'Documents.Additional.AttachedBack' | translate }}
          </ng-container>
        </button>

        <div *ngIf="additionalDocument" class="file">
          <button (click)="onRemoveAdditional()" [disabled]="isBusy[additionalDocumentType.ProofAddressAdditional]"
                  class="remove">
            <img alt="remove" src="/img/remove.svg">
          </button>
          <div> {{ additionalDocument.fileName }}</div>
          <img alt="mark" src="/img/mark.svg">
        </div>
      </div>
    </div>
  </ng-container>
</div>
